import {
  INIT_URL,
  SIGNOUT_USER_SUCCESS,
  USER_DATA,
  USER_TOKEN_SET,
  USER_STATISTICS_DETAILS,
  SIGNIN_USER,
  USER_STORE_FIND,
  USER_STORE_NOT_FOUND,
  USER_LOGOUT,
  SET_SUBSCRIPTION,
  LOAD_MENU
} from '../../constants/ActionTypes'

const storeStateVariable = {
  storeName: '',
  storeHash: '',
  reqNo: ''
}
const authdUserVariableData = {
  token: '',
  x1AUTH_SHA: '',
  x1AUTH_SHB: '',
  subscriptionExpiresOn: '',
  commonStoreConfigurations: null,
  value: false
}

const INIT_STATE = {
  token: localStorage.getItem('adminToken'),
  initURL: '',
  getStatistic: {},
  storeVariable: storeStateVariable,
  authdVariable: authdUserVariableData,
  skeletonLoading: true,
  setSubscription: null,
  reloadMenu: false
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }

    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        token: null,
        authUser: null,
        initURL: ''
      }
    }
    case USER_STORE_NOT_FOUND: {
      storeStateVariable.storeName = ''
      storeStateVariable.storeHash = ''
      return {
        ...state
      }
    }
    case LOAD_MENU: {
      return {
        ...state,
        reloadMenu: action.payload
      }
    }
    case SET_SUBSCRIPTION: {
      //setSubscription=action.payload;
      //setSubscription="osama";
      return {
        ...state,
        setSubscription: action.payload
      }
    }
    case USER_STORE_FIND: {
      //const result=userStore(action.payload)
      /* if(action.payload.value==true){
         state.storeName=action.payload.storeNameLoad;
         return state;
       }
       else{
         state.storeName="NF";
       }.*/
      storeStateVariable.storeName = action.payload.storeNameLoad
      storeStateVariable.storeHash = action.payload.storeHash
      storeStateVariable.reqNo = action.payload.reqNo
      return {
        ...state,
        //storeName:(action.payload.value==true)?action.payload.storeNameLoad:"NF"
        storeVariable: action.payload.value == true ? storeStateVariable : null
      }

      //state=result
    }
    case USER_LOGOUT: {
      return {
        ...state,
        storeVariable: null,
        authdVariable: null
      }
    }
    case SIGNIN_USER: {
      authdUserVariableData.token = action.payload.token
      authdUserVariableData.x1AUTH_SHA = action.payload.x1Auth_SHA
      authdUserVariableData.x1AUTH_SHB = action.payload.x1Auth_SHB
      authdUserVariableData.subscriptionExpiresOn =
        action.payload.subscriptionExpiresOn
      authdUserVariableData.value = action.payload.value
      authdUserVariableData.commonStoreConfigurations =
        action.payload.storeCommonConfigurations
      if (action.payload.value == true) {
        return {
          ...state,
          authdVariable:
            action.payload.value == true ? authdUserVariableData : null
        }
      }
      return {
        ...state
      }
    }
    case USER_DATA: {
      return {
        ...state,
        authUser: action.payload
      }
    }

    case USER_STATISTICS_DETAILS: {
      return {
        ...state,
        getStatistic: action.statistic
      }
    }

    case USER_TOKEN_SET: {
      return {
        ...state,
        token: action.payload
      }
    }
    default:
      return state
  }
}
